interface GConstructor<T> {
  new (): T;
}

// eslint-disable-next-line import/prefer-default-export
export function singleton<T>(Constructor: GConstructor<T>): T {
  return new Constructor();
}
